import React, { Component } from 'react';

export default class Practice extends Component {
  componentWillMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div className="18.jpg upper upper__then">
        <div className="captions">Контроль прохождения производственной и военной практики</div>
        <div className="usp__inputs">
          <div className="inputs__name">Рабочий учебный план</div>
          <div className="inputs__input">
            <input
              type="text"
              placeholder="Все"
              className="input__caption"
              value="Рабочий учебный план №15_КТ от 23.10.2015"
            />
          </div>
        </div>
        <div className="usp__inputs">
          <div className="inputs__name">Вид практики</div>
          <div className="inputs__input">
            <input type="text" placeholder="" className="input__caption" value="" />
          </div>
        </div>
        <div className="usp__inputs">
          <div className="inputs__name fix__inputs__name">Трудоёмкость, 1 3Е, часов</div>
          <div className="inputs__own small__input left">
            36
          </div>
        </div>
        <div className="usp__inputs arrow__down_hide">
          <div className="inputs__name fix__inputs__name">Продолжительность (нед.)</div>
          <div className="inputs__own small__input left">
            36
          </div>
        </div>
        <div className="usp__inputs left">
          <div className="inputs__name fix__inputs__name">Семестр</div>
          <div className="inputs__own retard left">
            1 семестр
          </div>
        </div>
        <div className="usp__inputs left usp__inputs_no-arrow">
          <div className="inputs__name">Место проведения</div>
          <div className="inputs__input">
            <input type="text" placeholder="" className="input__caption" value="" />
          </div>
        </div>
      </div>
    );
  }
}

